import React from "react";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from "../services/config";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import heroBackground from '../assets/images/shipping-banner.png';

export const ShippingPage: React.FC = () => {
  const location = useLocation();
  return (
    <>
      <Helmet>
        <title>Доставка и оплата — SAFONOVA</title>
        <meta name="description" content="Информация о способах доставки и оплаты заказов SAFONOVA: сроки, стоимость, способы оплаты" />
        <link rel="canonical" href={`${BASE_URL || ''}${location.pathname}${location.search || ''}`} />
        <meta property="og:title" content="Доставка и оплата — SAFONOVA" />
        <meta property="og:description" content="Информация о способах доставки и оплаты заказов SAFONOVA: сроки, стоимость, способы оплаты" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`${BASE_URL || ''}${location.pathname}${location.search || ''}`} />
        <meta property="og:image" content={`${BASE_URL || ''}/og-default.png`} />
      </Helmet>
      {/* Hero Section */}
      <section 
        // className="py-24 bg-content2"
        className="relative flex items-center py-32 md:py-40"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.10)), url('${heroBackground}')`,
          backgroundPosition: "center 40%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat"
        }}>
        <div className="container mx-auto px-6 md:px-12">
          <motion.div 
            className="max-w-3xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-light mb-6 text-white text-shadow">
              Доставка и <span className="font-medium">оплата</span>
            </h1>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-xl text-shadow">
              Информация о способах доставки и оплаты заказов
            </p>
          </motion.div>
        </div>
      </section>
        {/* <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-light mb-6">
              Доставка и <span className="font-medium">оплата</span>
            </h1>
            <p className="text-lg text-foreground/80 max-w-2xl mx-auto">
              Информация о способах доставки и оплаты заказов
            </p>
          </motion.div>
        </div>
      </section> */}

      {/* Shipping Methods */}
      <section className="py-16 bg-background">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-light mb-12 text-center">Способы <span className="font-medium">доставки</span></h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="border border-divider p-6"
            >
              <div className="bg-primary/10 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Icon icon="lucide:truck" className="text-primary" width={24} />
              </div>
              <h3 className="text-xl font-medium mb-3">СДЭК Курьерская доставка</h3>
              <p className="text-foreground/70 mb-4">
                Доставка курьером СДЭК по России до двери. Срок доставки: 2-7 рабочих дней в зависимости от региона.
              </p>
              <p className="font-medium">
                от 300 ₽
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="border border-divider p-6"
            >
              <div className="bg-primary/10 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Icon icon="lucide:package" className="text-primary" width={24} />
              </div>
              <h3 className="text-xl font-medium mb-3">СДЭК ПВЗ</h3>
              <p className="text-foreground/70 mb-4">
                Доставка в любой регион России где присуствую пункты выдачи заказов СДЭК. Срок доставки: 2-14 рабочих дней в зависимости от региона.
              </p>
              <p className="font-medium">
                от 150 ₽
              </p>
            </motion.div>

            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="border border-divider p-6"
            >
              <div className="bg-primary/10 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Icon icon="lucide:map-pin" className="text-primary" width={24} />
              </div>
              <h3 className="text-xl font-medium mb-3">Самовывоз</h3>
              <p className="text-foreground/70 mb-4">
                Вы можете забрать заказ самостоятельно из нашего офиса в Москве по адресу: ул. Арбат, 10, офис 205.
              </p>
              <p className="font-medium">
                Бесплатно
              </p>
            </motion.div> */}
          </div>

          <div className="mt-12 p-6 border border-divider bg-content2/50">
            <h3 className="text-xl font-medium mb-4">Важная информация о доставке</h3>
            <ul className="space-y-3">
              {/* <li className="flex items-start gap-3">
                <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                <span className="text-foreground/80">Бесплатная доставка при заказе от 5000 ₽ по Москве и от 7000 ₽ по России</span>
              </li> */}
              <li className="flex items-start gap-3">
                <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                <span className="text-foreground/80">Доставка осуществляется в рабочие дни с 10:00 до 19:00</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                <span className="text-foreground/80">Точное время доставки согласовывается с менеджером СДЭК</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon icon="lucide:check" className="text-primary mt-1" width={18} />
                <span className="text-foreground/80">Возможна доставка в выходные дни по предварительной договоренности</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Payment Methods */}
      <section className="py-16 bg-content2">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-light mb-12 text-center">Способы <span className="font-medium">оплаты</span></h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="border border-divider p-6"
            >
              <div className="bg-primary/10 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Icon icon="lucide:credit-card" className="text-primary" width={24} />
              </div>
              <h3 className="text-xl font-medium mb-3">Банковская карта</h3>
              <p className="text-foreground/70 mb-4">
                Оплата банковской картой на сайте (Visa, MasterCard, МИР). Безопасность платежей обеспечивается использованием SSL-протокола.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="border border-divider p-6"
            >
              <div className="bg-primary/10 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Icon icon="lucide:zap" className="text-primary" width={24} />
              </div>
              <h3 className="text-xl font-medium mb-3">Система быстрых платежей (СБП)</h3>
              <p className="text-foreground/70 mb-4">
                Мгновенный перевод по номеру телефона через приложение вашего банка. Без комиссии, деньги поступают сразу после оплаты.
              </p>
            </motion.div>

            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="border border-divider p-6"
            >
              <div className="bg-primary/10 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Icon icon="lucide:calendar" className="text-primary" width={24} />
              </div>
              <h3 className="text-xl font-medium mb-3">Рассрочка</h3>
              <p className="text-foreground/70 mb-4">
                Возможность оплатить покупку в рассрочку на срок от 2 до 12 месяцев. Доступно для заказов от 3000 ₽, требуется минимальный пакет документов.
              </p>
            </motion.div> */}
          </div>

          <div className="mt-12 p-6 border border-divider bg-background max-w-4xl mx-auto">
            <h3 className="text-xl font-medium mb-4">Информация об оплате</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Icon icon="lucide:info" className="text-primary mt-1" width={18} />
                <span className="text-foreground/80">При оплате банковской картой списание средств происходит сразу после подтверждения заказа</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon icon="lucide:info" className="text-primary mt-1" width={18} />
                <span className="text-foreground/80">Для юридических лиц возможна оплата по безналичному расчету</span>
              </li>
              <li className="flex items-start gap-3">
                <Icon icon="lucide:info" className="text-primary mt-1" width={18} />
                <span className="text-foreground/80">После оплаты вы получите электронный чек на указанный email</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};